import './Button.less';
import React from 'react';
import Icon from '../icon/Icon';

export default class Button extends React.Component {
    render() {
        const {
            name,
            title,
            tooltip,
            onClick = () => {},
            appearance = 'neutral', // neutral, primary
            size = 'medium', // small, medium, large
            disabled,
            icon,
            iconPosition = 'start', // start, end
            type = 'button',
        } = this.props;

        return <button
            type={type}
            className={`button ${name ? `${name}-button` : ''} appearance-${appearance} size-${size} ${disabled ? 'disabled' : ''}`}
            onClick={ev => disabled || onClick(ev)}
            aria-label={tooltip}
        >
            {
                icon &&
                iconPosition === 'start' &&
                <Icon name={icon}/>
            }
            <span>{title}</span>
            {
                icon &&
                iconPosition === 'end' &&
                <Icon name={icon}/>
            }
        </button>;
    }
}